module.exports = __webpack_public_path__ + "img/sm3_maskFIT_s.6d2409dc.png";